module.exports = "/_next/static/images/groww-76377aeff1a96ff59c22e013e2a083ac.png";